
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="relative bg-cover bg-center bg-no-repeat min-h-screen flex items-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/cfef6ab236753ac32fe0360fadf48e9d.jpg')`
      }}
    >
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="w-full flex items-center justify-between">
          <div className="w-full lg:w-1/2 text-white">
            <h1 className="text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              Expand Your
              <span className="text-orange-500 block">Marketing Horizon</span>
            </h1>
            <p className="text-xl mb-8 leading-relaxed opacity-90">
              We specialize in high-performing ad campaigns across Google, social networks, Outbrain, and more. Drive growth with targeted strategies that deliver measurable results.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                variant="primary" 
                size="lg"
                onClick={scrollToContact}
              >
                Start Your Campaign
              </Button>
              <Button 
                variant="outline" 
                size="lg"
                className="border-white text-white hover:bg-white hover:text-black"
              >
                View Our Work
              </Button>
            </div>
            <div className="mt-12 flex items-center space-x-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-orange-500">500+</div>
                <div className="text-sm opacity-80">Campaigns Launched</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-orange-500">300%</div>
                <div className="text-sm opacity-80">Average ROI</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-orange-500">24/7</div>
                <div className="text-sm opacity-80">Campaign Monitoring</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
